export const PROJECT_VIEWER_ONLY_PROJECT_NO = "10256866";

export const isProjectViewerOnlyProject = (projectNo: string | number | null | undefined) =>
  String(projectNo) === PROJECT_VIEWER_ONLY_PROJECT_NO;
